<script>
export default {
  name: 'VoiceFormattingButton',
  methods: {
    onClick () {
      // Placeholder for a future voice formatting picker (similar to PlaybackFieldPickerButton).
    },
  },
}
</script>

<template>
  <Button
    compact
    icon="add"
    label="Voice Formatting"
    class="voice-formatting-picker"
    disabled
    @click="onClick"
  />
</template>

<style lang="scss" scoped>
.voice-formatting-picker {
  margin-left: auto;
}
</style>
